import moment from "moment";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import RestApi, { studyPressBaseUrl } from '@/config/api_config'
import Hashids from 'hashids'

export default {
    data () {
        return {
          pagination: {
            currentPage: 1,
            totalRows: 0,
            // perPage: this.$store.state.commonObj.perPage,
            perPage: 20,
            slOffset: 1
          },
          user: JSON.parse(localStorage.getItem('userData')),
          token: localStorage.getItem('access_token'),
          photoPath: localStorage.getItem('photoPath'),
          editItemId: 0,
          destroyCall: true,
          sitePrefix: '/site'
        }
    },
    computed: {
        // loading () {
        //   return this.$store.state.commonObj.loading
        // },
        listReload () {
          return this.$store.state.commonObj.listReload
        },
        loadingState () {
          if (this.listReload) {
            return true
          } else if (this.loading) {
              return true
          } else {
            return false
          }
        },
        listData () {
          return this.$store.state.list
        },
        memberShip () {
          return 1
        },
        authUser:function(){
            return this.cn(this.$store.state, 'authUser', null);
        }
    },
    watch: {
      listReload: function (newVal, oldVal) {
        if (newVal) {
          this.loadData()
        }
      }
    },
    created () {
      // const value = window.addEventListener('beforeunload', (e) => {
      //     e.preventDefault();
      //     console.log('e===', e)
      //     console.log('e.preventDefault()', e.preventDefault())
      //     alert('Close tab alert')
      //     this.updateAuthLoginData()
      //     e.returnValue = 'Are you sure to close tab?';
      // }, false)

      // console.log('value',value)

      // const value = window.onbeforeunload = function () {
      //     return 'Are you really want to perform the action?';
      // }

      // if (value) {
      //   this.updateAuthLoginData()
      // }

      
      // document.addEventListener('beforeunload', this.updateAuthLoginData());
    },
    mounted () {
      // window.addEventListener('beforeunload', function (e) {
      //   window.alert("test")
      //   e.preventDefault();
      //   e.returnValue = 'Are you sure to close tab?';
      //   this.updateAuthLoginData()
      // });
    },
    methods: {
      updateAuthLoginData: async function () {
        try {
          this.loading = true
          const result = await RestApi.postData(studyPressBaseUrl, `api/v1/ajax/update_auth_user_login_data`)
          this.loading = false
  
        } catch (error) {
          this.loading = false
        }
      },
      resetId () {
        this.editItemId = 0
      },
      paginationData (data) {
        this.pagination.currentPage = data.current_page
        this.pagination.totalRows = data.total
        this.pagination.perPage = data.per_page
        this.pagination.slOffset = data.per_page * this.pagination.currentPage - data.per_page + 1
      },
      fDay: function (value, format = "dddd") {
          return moment.utc(value).local().format(format);
      },
      dFullDate: function (value, format = "MMMM D, YYYY") {
          return moment.utc(value).local().format(format);
      },
      dDate: function (value, format = "D MMM YYYY") {
          return moment.utc(value).local().format(format);
      },
      dDateTime: function (value, format = "D MMM YYYY LT") {
          return moment.utc(value).local().format(format);
      },
      dTime: function (value, format = "LT") {
          return moment.utc(value).local().format(format);
      },
      dRealTime: function (value, format = "LT") {
          return moment(value).local().format(format);
      },
      rTime: function (value) {
          var today = new Date();
          var year = today.getFullYear();
          var mes = today.getMonth()+1;
          var dia = today.getDate();
          var fecha =year+"-"+mes+"-"+dia;
          return moment(fecha + ' ' + value).format('LT');
      },
      getBetweenHour: function (startTime, endTime) {
          const myEndTime = endTime ? new Date(endTime) : new Date();
          const myStartTime = new Date(startTime);
          const diffMs = myEndTime - myStartTime;
          const diffHrs = Math.floor((diffMs % 86400000) / 3600000);
          const diffMins = Math.round(
              ((diffMs % 86400000) % 3600000) / 60000
          );
          if (diffHrs > 1) {
              return `${diffHrs} Hours ${diffMins} min`;
          } else {
              return `${diffHrs} Hour ${diffMins} min`;
          }
      },
      checkCurrentDateLessThenOrEqualDate: function (dateValue) {
          const currentDate = this.dDate(new Date(), 'YYYY-MM-DD')
          const anotherDate = this.dDate(dateValue, 'YYYY-MM-DD')
          if (anotherDate >= currentDate) {
              return true
          } else {
              return false
          }
      },
      checkCurrentDateGreaterThenOrEqualDate: function (dateValue) {
          const currentDate = this.dDate(new Date(), 'YYYY-MM-DD')
          const anotherDate = this.dDate(dateValue, 'YYYY-MM-DD')
          if (anotherDate <= currentDate) {
              return true
          } else {
              return false
          }
      },
      ageCount: function (startDate, endDate = new Date()) {
        const dob = new Date(startDate)
        const month_diff = endDate - dob.getTime()
        const age_dt = new Date(month_diff)
        const year = age_dt.getUTCFullYear()
        const age = Math.abs(year - 1970)
        if (age > 1) {
          return age + ' Years'
        } else {
          return age + ' Year'
        }
      },
      ageYearMonthCount: function (startDate, endDate = new Date()) {
        const dob = new Date(startDate)
        //extract the year, month, and date from user date input  
        let dobYear = dob.getYear();  
        let dobMonth = dob.getMonth();  
        let dobDate = dob.getDate();
  
        //extract the year, month, and date from current date  
        let currentYear = endDate.getYear();  
        let currentMonth = endDate.getMonth();  
        let currentDate = endDate.getDate();
        
        //get years  
        let yearAge = currentYear - dobYear;
        let monthAge = ''
          
        //get months  
        if (currentMonth >= dobMonth)  
          //get months when current month is greater  
          monthAge = currentMonth - dobMonth;  
        else {  
          yearAge--;  
          monthAge = 12 + currentMonth - dobMonth;  
        }  
        let dateAge = ''
        //get days  
        if (currentDate >= dobDate)  
          //get days when the current date is greater  
          dateAge = currentDate - dobDate;  
        else {
          monthAge--;  
          dateAge = 31 + currentDate - dobDate;  
        
          if (monthAge < 0) {  
            monthAge = 11;  
            yearAge--;  
          }  
        }  
        //group the age in a single variable  
        let age = {
          years: yearAge,  
          months: monthAge,  
          days: dateAge  
        }
  
        let ageString = ''
  
        if ( (age.years > 0) && (age.months > 0) && (age.days > 0) ) {
          ageString = age.years + " Years " + age.months + " Months";  
        } else if ( (age.years == 0) && (age.months == 0) && (age.days > 0) ) {
          ageString = "Only " + age.days + " Days!";  
        }
        //when current month and date is same as birth date and month  
        else if ( (age.years > 0) && (age.months == 0) && (age.days == 0) ) {
          ageString = age.years +  " Years. Happy Birthday!!";  
        } else if ( (age.years > 0) && (age.months > 0) && (age.days == 0) ) {
          ageString = age.years + " Years and " + age.months + " Months";  
        } else if ( (age.years == 0) && (age.months > 0) && (age.days > 0) ) {
          ageString = age.months + " Months";  
        } else if ( (age.years > 0) && (age.months == 0) && (age.days > 0) ) {
          ageString = age.years + " Years and " + age.days + " Days";
        } else if ( (age.years == 0) && (age.months > 0) && (age.days == 0) ) {
          ageString = age.months + " Months.";  
        }
        //when current date is same as dob(date of birth)  
        // else ageString = "Welcome to Earth! <br> It's first day on Earth!";
        else ageString = "O Day";
  
        return ageString
      },
      ageFullCount: function (startDate, endDate = new Date()) {
        const dob = new Date(startDate)
        //extract the year, month, and date from user date input  
        let dobYear = dob.getYear();  
        let dobMonth = dob.getMonth();  
        let dobDate = dob.getDate();
  
        //extract the year, month, and date from current date  
        let currentYear = endDate.getYear();  
        let currentMonth = endDate.getMonth();  
        let currentDate = endDate.getDate();
        
        //get years  
        let yearAge = currentYear - dobYear;
        let monthAge = ''
          
        //get months  
        if (currentMonth >= dobMonth)  
          //get months when current month is greater  
          monthAge = currentMonth - dobMonth;  
        else {  
          yearAge--;  
          monthAge = 12 + currentMonth - dobMonth;  
        }  
        let dateAge = ''
        //get days  
        if (currentDate >= dobDate)  
          //get days when the current date is greater  
          dateAge = currentDate - dobDate;  
        else {
          monthAge--;  
          dateAge = 31 + currentDate - dobDate;  
        
          if (monthAge < 0) {  
            monthAge = 11;  
            yearAge--;  
          }  
        }  
        //group the age in a single variable  
        let age = {
          years: yearAge,  
          months: monthAge,  
          days: dateAge  
        }
  
        let ageString = ''
  
        if ( (age.years > 0) && (age.months > 0) && (age.days > 0) ) {
          ageString = age.years + " Years " + age.months + " Months and " + age.days + " Days";  
        } else if ( (age.years == 0) && (age.months == 0) && (age.days > 0) ) {
          ageString = "Only " + age.days + " Days!";  
        }
        //when current month and date is same as birth date and month  
        else if ( (age.years > 0) && (age.months == 0) && (age.days == 0) ) {
          ageString = age.years +  " Years. Happy Birthday!!";  
        } else if ( (age.years > 0) && (age.months > 0) && (age.days == 0) ) {
          ageString = age.years + " Years and " + age.months + " Months.";  
        } else if ( (age.years == 0) && (age.months > 0) && (age.days > 0) ) {
          ageString = age.months + " Months and " + age.days + " Days";  
        } else if ( (age.years > 0) && (age.months == 0) && (age.days > 0) ) {
          ageString = age.years + " Years and " + age.days + " Days";  
        } else if ( (age.years == 0) && (age.months > 0) && (age.days == 0) ) {
          ageString = age.months + " Months.";  
        }
        //when current date is same as dob(date of birth)  
        // else ageString = "Welcome to Earth! <br> It's first day on Earth!";
        else ageString = "O Day";
  
        return ageString
      },
      dDate: function (value, format='D MMM YYYY') {
        return moment.utc(value).local().format(format)
      },
      dDateTime: function (value, format='D MMM YYYY LT') {
        return moment.utc(value).local().format(format)
      },
      dTime: function (value, format='LT') {
        return moment.utc(value).local().format(format)
      },
      dMonth: function (value, format='MMM YYYY') {
        return moment(value).format(format)
      },
      dYear: function (value, format='YYYY') {
        return moment(value).format(format)
      },
      dNow: function (value) {
        // return moment(value).fromNow()
        return moment.utc(value).local().fromNow()
      },
      integer: function (value = 0) {
          const integerValue = value | 0;
          return Number(integerValue).toLocaleString();
      },
      float: function (value = 0.0) {
          const integerValue = parseFloat(value);
          return Number(integerValue).toLocaleString();
      },
      float2: function (value = 0.0) {
          const double = parseFloat(value).toFixed(2);
          return Number(double).toLocaleString();
      },
      successMsg: function (msg, title=null) {
          return this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: title ? title : `Success`,
                variant: 'success',
                text: msg,
              },
            })
      },
      errMsg: function (msg, title=null) {
          return this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: title ? title : `Error`,
                variant: 'danger',
                text: msg,
              },
            })
      },
      resMsg: function (msg, variant = 'success', title = null) {
          let myTitle
          if (title) {
            myTitle = title
          } else {
            myTitle = variant == 'success' ? 'Success' : 'Error'
          }
          return this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: myTitle,
                variant: variant,
                text: msg,
              },
            })
      },
      cn: function (obj, input, if_false = "") {
          var elements = input.split(".");

          for (var i = 0; i < elements.length; i++) {
              if (!obj || !obj[elements[i]]) {
                  return if_false;
              }

              obj = obj[elements[i]];
          }

          if (obj) return obj;
          return if_false;
      },
      avatarText2: function (value) {
          var matches = value.match(/\b(\w)/g);

          if (matches.length == 1) {
              return value.substring(0, 2).toLocaleUpperCase();
          } else {
              const data = matches.filter((item, index) => {
                  if (index < 2) {
                      return Object.assign({}, item);
                  }
              });
              return data.join("");
          }
      },
      hash_id: function (value, encode = true) {
        var hashids = new Hashids('hashids_for_passing_url_id', 32);
        if (encode) {
          return hashids.encode(value);
        } else {
          return hashids.decode(value);
        }
      },
      getAuthData: async function () {
        
        try {
  
          this.loading = true
          const result = await RestApi.getData(studyPressBaseUrl, `/api/v1/ajax/get_auth_user`)
          // console.log(' result.data.authUser =====', result.data.authUser)
          const myObject = {}
          myObject.role = result.data.authUser.role_id === 1 ? 'admin' : 'admin'
          myObject.ability = [{action: "manage", subject: "all"}]
          const userData = Object.assign({}, result.data.authUser, myObject)
          // console.log('userData =====', userData)
          this.$store.dispatch('AuthUser', {userData})
          this.$store.dispatch('studyGroups', result.data.studyGroups)
          this.$store.dispatch('userEnrollment', result.data.userEnrollment)
          localStorage.removeItem('userEnrollment')
          localStorage.setItem('userEnrollment', JSON.stringify(result.data.userEnrollment))
          this.loading = false
  
        } catch (error) {
          // this.errMsg(error)
          this.loading = false
        }
      },
      getFormattedQuestion: function (item) {
        const questionSplit = item.question.split('</p>')[0]
        const question = questionSplit.split('<p>')[1]
        return question
      },
      getFormattedOptions: function (item) {
        const options = item.options.replace('@@', '')
        const splitOptions = options.split('///')
        const correctAnsIndex = this.getCorrectOptionIndex(item)

        let absoluteOptions = []

        splitOptions.forEach((row, index) => {
          if (correctAnsIndex > -1) {
            const is_correct = index === correctAnsIndex ? true : false
            const qOptions = {
              text: row,
              value: index,
              is_correct: is_correct,
              correctAnsIndex: correctAnsIndex,
              bg_color: 'radio_option_default_custom_design',
              text_color: 'text-primary',
            }
            absoluteOptions.push(qOptions)
          }
        })
        return absoluteOptions
      },
      getCorrectOptionIndex: function (item) {
        const mySplitSlash = item.options.split('///')
        const correctAnsIndex = mySplitSlash.findIndex(element => element.includes("@@"))
        return correctAnsIndex
      },
      getCorrectAnswer: function (item) {
        const correctAnsIndex = this.getCorrectOptionIndex(item)
        const correctAns = this.getFormattedOptions(item)[correctAnsIndex] ?? null
        return correctAns.text ?? ''
      }
    },
    beforeDestroy () {
      if (this.destroyCall) {
        this.$store.dispatch('resetList', [])
      }
    }
}
